export class FormaPago {
	constructor(
	    	public id: String = "",
			public nombre: String = "",
			public status: String = "",
			public usuario_id: String = "",
			public empresa_id: String = "",
	){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/forma-pago.ts